import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  NotificationService as EmployeePortalNotificationService,
  UpdateNotificationCommand,
} from "app/api/sidc-services/employee-portal/main";
import { takeUntil } from 'rxjs/operators';

import { NotificationsService } from "app/layout/components/navbar/navbar-notification/notifications.service";
import { environment } from "environments/environment";
import { Subject } from "rxjs";

// Interface
interface notification {
  notifications: [];
  messages: [];
  systemMessages: [];
  system: Boolean;
}

@Component({
  selector: "app-navbar-notification",
  templateUrl: "./navbar-notification.component.html",
})
export class NavbarNotificationComponent implements OnInit {
  // Public
  public notifications: any = {
    notifications: [],
  };
  private unsubscribeAll: Subject<any>;
  unreadNotificationsCount: number;
  private intervalId: any;
  
  /**
   *
   * @param {NotificationsService} _notificationsService
   */
  constructor(
    private _notificationsService: NotificationsService,
    private notificationService: EmployeePortalNotificationService,
    private router: Router
  ) {
    this.unsubscribeAll = new Subject();
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    console.log("notiication");
    // this._notificationsService.onApiDataChange.subscribe(res => {
    //   this.notifications = res;
    //   console.log('res',res);
    // });
    this.startInterval();
    this.setPage();
  }
  startInterval(): void {
    this.intervalId = setInterval(() => {
      this.setPage();
    }, 5000);
  }
  clearInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  setPage() {
    //this.blockUI.start();
    //this.notificationService.apiVversionNotificationGetByEmployeeCodeGet(environment.apiVersion).pipe(takeUntil(this.unsubscribeAll)).subscribe(response => {
    this.notificationService
      .apiVversionNotificationGetByEmployeeCodeGet(environment.apiVersion)
      .subscribe(
        (response) => {
          console.log("notiffff", response);
          this.notifications = response;
          this.unreadNotificationsCount = this.notifications.notifications.filter(notification => !notification.isViewed).length;
        },
        (httpError: HttpErrorResponse) => {
          //this.blockUI.stop();
        }
      );
  }

  onClickNotification(selectedNotification) {
    console.log("selectedNotification", selectedNotification);
    // let updateNotificationCommand: UpdateNotificationCommand = {
    //   id: selectedNotification.id,
    //   isViewed: true,
    // };
    // console.log("updateNotificationCommand", updateNotificationCommand);

    // this.notificationService
    //   .apiVversionNotificationIdPut(
    //     selectedNotification.id,
    //     environment.apiVersion,
    //     updateNotificationCommand
    //   )
    //   .pipe(takeUntil(this.unsubscribeAll))
    //   .subscribe(response => {
    //     this.router.navigate([selectedNotification.path]);
    //     this.setPage();
    //   }, (httpError: HttpErrorResponse) => {


        
    //   });

      this.router.navigate([selectedNotification.path]);



  }
}
